import { invokeApi } from "../../bl_libs/invokeApi";

export const get_school_students_api = async () => {
  const requestObj = {
    path: `api/school/students`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

/**
 * How each member of staff is doing: students, sessions delivered, debriefs
 * owed, lesson decisions, notes. Owner, manager and front desk only.
 */
export const get_staff_progress_api = async (days = 30) => {
  const requestObj = {
    path: `api/school/staff/progress`,
    method: "GET",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    queryParams: { days },
  };
  return invokeApi(requestObj);
};

export const get_school_staff_api = async () => {
  const requestObj = {
    path: `api/school/staff`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const add_school_staff_api = async (data) => {
  const requestObj = {
    path: `api/school/staff/add`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_school_staff_api = async (staffId, data) => {
  const requestObj = {
    path: `api/school/staff/${staffId}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const send_staff_password_reset_api = async (staffId) => {
  const requestObj = {
    path: `api/school/staff/${staffId}/password-reset`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const delete_school_staff_api = async (staffId) => {
  const requestObj = {
    path: `api/school/staff/${staffId}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

/**
 * One person's profile in a single read: permissions, onboarding, earnings,
 * upcoming sessions and the tasks they set. `permissions.why` explains any
 * action the caller may not take.
 */
export const get_staff_overview_api = async (staffId, days = 30) => {
  const requestObj = {
    path: `api/school/staff/${staffId}/overview`,
    method: "GET",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    queryParams: { days },
  };
  return invokeApi(requestObj);
};

// formData carries the file under "photo"; invokeApi drops the JSON
// content-type so the browser sets the multipart boundary.
export const upload_staff_photo_api = async (staffId, formData) => {
  const requestObj = {
    path: `api/school/staff/${staffId}/photo`,
    method: "POST",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    postData: formData,
  };
  return invokeApi(requestObj);
};

export const get_school_dashboard_api = async () => {
  const requestObj = {
    path: `api/school/dashboard`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_school_details_api = async () => {
  const requestObj = {
    path: `api/school/details`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const update_school_details_api = async (data) => {
  const requestObj = {
    path: `api/school/details`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const add_school_student_api = async (data) => {
  const requestObj = {
    path: `api/school/students`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const delete_school_student_api = async (studentId) => {
  const requestObj = {
    path: `api/school/students/${studentId}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const update_school_student_api = async (studentId, data) => {
  const requestObj = {
    path: `api/school/students/${studentId}/profile`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const send_student_password_reset_api = async (studentId) => {
  const requestObj = {
    path: `api/school/students/${studentId}/password-reset`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const resend_student_invite_api = async (studentId) => {
  const requestObj = {
    path: `api/school/students/${studentId}/resend-invite`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_school_student_detail_api = async (studentId) => {
  const requestObj = {
    path: `api/school/students/${studentId}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_school_student_usage_chart_api = async (studentId, period = "month") => {
  const requestObj = {
    path: `api/school/students/${studentId}/usage-chart`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    queryParams: { period },
  };
  return invokeApi(requestObj);
};

export const generate_school_student_ai_summary_api = async (studentId) => {
  const requestObj = {
    path: `api/dashboard/ai-feedback/${studentId}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_school_branding_api = async () => {
  const requestObj = {
    path: `api/school/branding`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_school_usage_chart_api = async (period = "week") => {
  const requestObj = {
    path: `api/school/usage-chart`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    queryParams: { period },
  };
  return invokeApi(requestObj);
};

export const get_student_subject_performance_api = async (studentId, license = "PPL") => {
  const requestObj = {
    path: `api/school/students/${studentId}/subject-performance`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    queryParams: { license },
  };
  return invokeApi(requestObj);
};

export const get_all_students_adaptive_grades_api = async (category = "PPL") => {
  const requestObj = {
    path: `api/school/students-adaptive-grades`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    queryParams: { category },
  };
  return invokeApi(requestObj);
};

// The instructor acted on a "worth knowing" note (how: propose | task | message | dismiss).
export const act_on_coaching_api = async (studentId, key, how) => invokeApi({
  path: `api/school/students/${studentId}/coaching/act`,
  method: "POST",
  headers: { "x-sh-auth": localStorage.getItem("token") },
  postData: { key, how },
});

// What to do with this student next: actions with evidence and a call to action.
export const get_student_coaching_api = async (studentId) => invokeApi({
  path: `api/school/students/${studentId}/coaching`,
  method: "GET",
  headers: { "x-sh-auth": localStorage.getItem("token") },
});

// Everything the student has been doing: lessons, reading, practice, mocks, rounds.
export const get_student_activity_api = async (studentId, days = 30) => invokeApi({
  path: `api/school/students/${studentId}/activity`,
  method: "GET",
  headers: { "x-sh-auth": localStorage.getItem("token") },
  queryParams: { days },
});

// The Adapt+ exam picture of one student (estimate, pass chance, ready date,
// weakest areas). The course is resolved server-side from the school.
export const get_student_knowledge_api = async (studentId, subject = null) => {
  const requestObj = {
    path: `api/school/students/${studentId}/knowledge`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    queryParams: subject ? { subject } : {},
  };
  return invokeApi(requestObj);
};

export const get_student_adaptive_grades_api = async (studentId, category = "PPL") => {
  const requestObj = {
    path: `api/school/students/${studentId}/adaptive-grades`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    queryParams: { category },
  };
  return invokeApi(requestObj);
};

export const get_student_topic_performance_api = async (studentId, subject, license = "PPL") => {
  const requestObj = {
    path: `api/school/students/${studentId}/topic-performance`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    queryParams: { subject, license },
  };
  return invokeApi(requestObj);
};

export const get_student_learn_progress_api = async (studentId, subject, license = "PPL") => {
  const requestObj = {
    path: `api/school/students/${studentId}/learn-progress`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    queryParams: { subject, license },
  };
  return invokeApi(requestObj);
};

export const get_school_health_summary_api = async () => {
  const requestObj = {
    path: `api/school/health-summary`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_school_board_api = async (category = "PPL") => {
  const requestObj = {
    path: `api/school/board`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    queryParams: { category },
  };
  return invokeApi(requestObj);
};

export const acknowledge_school_board_situation_api = async (situationId, situationType) => {
  const requestObj = {
    path: `api/school/board/acknowledge`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: { situationId, situationType },
  };
  return invokeApi(requestObj);
};

export const get_school_activity_feed_api = async () => {
  const requestObj = {
    path: `api/school/activity-feed`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_school_instructor_rollup_api = async () => {
  const requestObj = {
    path: `api/school/instructor-rollup`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_school_student_rankings_api = async () => {
  const requestObj = {
    path: `api/school/student-rankings`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const generate_student_mistake_briefing_api = async (studentId, { subject = null, forceRegenerate = false } = {}) => {
  const requestObj = {
    path: `api/school/students/${studentId}/generate-mistake-briefing`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: { subject, forceRegenerate },
  };
  return invokeApi(requestObj);
};

export const get_students_list_api = async (search = "", limit = 50, offset = 0) => {
  const requestObj = {
    path: `api/admin/students-list`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    queryParams: { search, limit, offset },
  };
  return invokeApi(requestObj);
};

export const get_student_analytics_api = async (studentId) => {
  const requestObj = {
    path: `api/admin/student/${studentId}/analytics`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const student_analysis_chat_api = async (message, studentId = null, conversationHistory = []) => {
  const requestObj = {
    path: `api/admin/student-analysis-chat`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: {
      message,
      studentId,
      conversationHistory,
    },
  };
  return invokeApi(requestObj);
};

export const submit_school_feedback_api = async (data) => {
  const requestObj = {
    path: `api/feedback`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const get_school_feedback_list_api = async (params = {}) => {
  const requestObj = {
    path: `api/feedback`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    queryParams: params,
  };
  return invokeApi(requestObj);
};

export const get_school_feedback_api = async (feedbackId) => {
  const requestObj = {
    path: `api/feedback/${feedbackId}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const update_school_feedback_status_api = async (feedbackId, status) => {
  const requestObj = {
    path: `api/feedback/${feedbackId}/status`,
    method: "PATCH",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: { status },
  };
  return invokeApi(requestObj);
};

export const get_school_feedback_stats_api = async () => {
  const requestObj = {
    path: `api/feedback/stats/summary`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

// ============================================
// STUDENT COMMENTS (Timeline Notes)
// ============================================

export const get_student_comments_api = async (studentId, limit = 50, offset = 0) => {
  const requestObj = {
    path: `api/school/students/${studentId}/comments`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    queryParams: { limit, offset },
  };
  return invokeApi(requestObj);
};

export const add_student_comment_api = async (studentId, content) => {
  const requestObj = {
    path: `api/school/students/${studentId}/comments`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: { content },
  };
  return invokeApi(requestObj);
};

export const update_student_comment_api = async (studentId, commentId, data) => {
  const requestObj = {
    path: `api/school/students/${studentId}/comments/${commentId}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const delete_student_comment_api = async (studentId, commentId) => {
  const requestObj = {
    path: `api/school/students/${studentId}/comments/${commentId}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_favorite_students_api = async () => {
  const requestObj = {
    path: `api/school/favorites`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const toggle_favorite_student_api = async (studentId) => {
  const requestObj = {
    path: `api/school/students/${studentId}/favorite`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

// ── The student record ───────────────────────────────────────────────────────
// One GET assembles the whole record server-side (services/studentRecordService).
// The client renders it; it does not merge collections.

export const get_student_record_api = async (studentId) => {
  const requestObj = {
    path: `api/school/students/${studentId}/record`,
    method: "GET",
    headers: { "x-sh-auth": localStorage.getItem("token") },
  };
  return invokeApi(requestObj);
};

export const create_student_task_api = async (studentId, data) => {
  const requestObj = {
    path: `api/school/students/${studentId}/tasks`,
    method: "POST",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    postData: data,
  };
  return invokeApi(requestObj);
};

/**
 * A set of actionables assigned in one go. Each item becomes its own task with
 * its own countable target; they share a sequenceId so the student reads them
 * as one checklist, and one email goes out for the set.
 */
export const set_student_homework_api = async (studentId, data) => {
  const requestObj = {
    path: `api/school/students/${studentId}/homework`,
    method: "POST",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    postData: data,
  };
  return invokeApi(requestObj);
};

/** What has been set, with progress against each target. */
export const get_student_tasks_api = async (studentId) => {
  const requestObj = {
    path: `api/school/students/${studentId}/tasks`,
    method: "GET",
    headers: { "x-sh-auth": localStorage.getItem("token") },
  };
  return invokeApi(requestObj);
};

/** action: "approve" | "dismiss" | "done" */
export const update_student_task_api = async (studentId, taskId, action) => {
  const requestObj = {
    path: `api/school/students/${studentId}/tasks/${taskId}`,
    method: "PUT",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    postData: { action },
  };
  return invokeApi(requestObj);
};

// Reaches the student — in-app and by email — unlike a note, which is private
// to the instructor. { body, relatedType?, relatedId? }
export const message_student_api = async (studentId, data) => {
  const requestObj = {
    path: `api/school/students/${studentId}/message`,
    method: "POST",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const add_record_note_api = async (studentId, data) => {
  const requestObj = {
    path: `api/school/students/${studentId}/notes`,
    method: "POST",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const approve_session_summary_api = async (studentId, bookingId, body) => {
  const requestObj = {
    path: `api/school/students/${studentId}/sessions/${bookingId}/summary`,
    method: "PUT",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    postData: body ? { body } : {},
  };
  return invokeApi(requestObj);
};

export const get_session_transcript_api = async (studentId, bookingId) => {
  const requestObj = {
    path: `api/school/students/${studentId}/sessions/${bookingId}/transcript`,
    method: "GET",
    headers: { "x-sh-auth": localStorage.getItem("token") },
  };
  return invokeApi(requestObj);
};

export const get_session_recording_api = async (studentId, bookingId) => {
  const requestObj = {
    path: `api/school/students/${studentId}/sessions/${bookingId}/recording`,
    method: "GET",
    headers: { "x-sh-auth": localStorage.getItem("token") },
  };
  return invokeApi(requestObj);
};

// ── The work queue ───────────────────────────────────────────────────────────
// What needs you today, ranked, every row opening a student record. Scoped
// server-side by role: an owner gets the school, a CFI gets their own students.

// scope "mine" narrows to the caller's own students whatever their role — an
// owner who also teaches needs both answers and they are different. It can only
// ever narrow, never widen.
export const get_work_queue_api = async ({ limit, scope } = {}) => {
  const qs = new URLSearchParams();
  if (limit) qs.set("limit", String(limit));
  if (scope) qs.set("scope", scope);
  const q = qs.toString();
  const requestObj = {
    path: `api/school/work-queue${q ? `?${q}` : ""}`,
    method: "GET",
    headers: { "x-sh-auth": localStorage.getItem("token") },
  };
  return invokeApi(requestObj);
};

export const get_school_utilisation_api = async (days = 30) => {
  const requestObj = {
    path: `api/school/reports/utilisation?days=${days}`,
    method: "GET",
    headers: { "x-sh-auth": localStorage.getItem("token") },
  };
  return invokeApi(requestObj);
};

export const get_school_run_rate_api = async (months = 6) => {
  const requestObj = {
    path: `api/school/reports/run-rate?months=${months}`,
    method: "GET",
    headers: { "x-sh-auth": localStorage.getItem("token") },
  };
  return invokeApi(requestObj);
};

// The roster page's only call — every student with the four facts that decide
// whether to act, plus counts computed from the same rows they filter.
export const get_school_roster_api = async () => {
  const requestObj = {
    path: `api/school/students/roster`,
    method: "GET",
    headers: { "x-sh-auth": localStorage.getItem("token") },
  };
  return invokeApi(requestObj);
};

/**
 * Move a student across the pipeline board.
 * to: "struggling" | "studying" only — Offered and Booked follow from a real
 * offer and a real answer, so they are not drop targets.
 */
export const move_student_pipeline_api = async (studentId, to, note) => {
  const requestObj = {
    path: `api/school/students/${studentId}/pipeline`,
    method: "PUT",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    postData: { to, ...(note ? { note } : {}) },
  };
  return invokeApi(requestObj);
};

// ── what the front desk can do ───────────────────────────────────────────────
//
// Every other action on the pipeline board proposes or answers against the
// CALLER's diary, so a non-teaching owner or receptionist had no move at all.
// These three are theirs: hand a student to a CFI, chase one sitting on an
// expiring request, and see who can be handed to.

export const refer_student_api = async (studentId, data) => {
  const requestObj = {
    path: `api/school/students/${studentId}/refer`,
    method: "POST",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const nudge_request_api = async (studentId) => {
  const requestObj = {
    path: `api/school/students/${studentId}/nudge-request`,
    method: "POST",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    postData: {},
  };
  return invokeApi(requestObj);
};

/**
 * Who can teach here. `excludeSelf` drops the caller and is OPT-IN, because the
 * two callers want opposite things: a referral picker must not offer you
 * yourself, while scheduling a group class must, since you are usually the one
 * teaching it.
 */
export const get_bookable_instructors_api = async ({ excludeSelf = false } = {}) => {
  const requestObj = {
    path: `api/school/instructors/bookable`,
    method: "GET",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    ...(excludeSelf ? { queryParams: { excludeSelf: "1" } } : {}),
  };
  return invokeApi(requestObj);
};

// ── group sessions ───────────────────────────────────────────────────────────
//
// The school side of a group class. Until these existed the only group-session
// routes were student-facing join/leave/list, and the two classes in production
// were written by a seed script — a school that had to call off Thursday's
// class had no way to do it.

export const get_group_sessions_api = async (params = {}) => {
  const q = new URLSearchParams(Object.entries(params).filter(([, v]) => v)).toString();
  return invokeApi({
    path: `api/school/group-sessions${q ? `?${q}` : ""}`,
    method: "GET",
    headers: { "x-sh-auth": localStorage.getItem("token") },
  });
};

export const create_group_session_api = async (data) =>
  invokeApi({
    path: `api/school/group-sessions`,
    method: "POST",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    postData: data,
  });

export const update_group_session_api = async (id, data) =>
  invokeApi({
    path: `api/school/group-sessions/${id}`,
    method: "PUT",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    postData: data,
  });

/** Cancels the class AND settles every seat — see the controller. */
export const cancel_group_session_api = async (id, reason = "") =>
  invokeApi({
    path: `api/school/group-sessions/${id}/cancel`,
    method: "POST",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    postData: { reason },
  });

/** state: booked | waitlisted | cancelled | attended | no_show */
export const set_group_attendee_state_api = async (id, studentId, state, reason = "") =>
  invokeApi({
    path: `api/school/group-sessions/${id}/attendees/${studentId}`,
    method: "POST",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    postData: { state, reason },
  });

// The actual questions a student has been seeing on a topic — question text
// where it was persisted, plus what they chose against what was right.
/**
 * Work set across the school with its progress, the diary ahead, and revenue.
 * Scoped by the caller's role on the server — ?scope=mine only ever narrows.
 */
export const get_school_pulse_api = async ({ days = 14, mine = false } = {}) => {
  const requestObj = {
    path: `api/school/pulse`,
    method: "GET",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    queryParams: { days: String(days), ...(mine ? { scope: "mine" } : {}) },
  };
  return invokeApi(requestObj);
};

/** One topic, split into the subtopics the course puts under it. */
export const get_student_subtopics_api = async (studentId, { subject, topic } = {}) => {
  const requestObj = {
    path: `api/school/students/${studentId}/subtopics`,
    method: "GET",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    queryParams: { subject, topic },
  };
  return invokeApi(requestObj);
};

export const get_student_questions_api = async (studentId, { subject, topic = null, wrongOnly = false, limit = 20 } = {}) => {
  const requestObj = {
    path: `api/school/students/${studentId}/questions`,
    method: "GET",
    headers: { "x-sh-auth": localStorage.getItem("token") },
    queryParams: { subject, ...(topic ? { topic } : {}), wrongOnly: String(wrongOnly), limit: String(limit) },
  };
  return invokeApi(requestObj);
};
